<template>
  <v-dialog v-model="isDialogOpen" scrollable persistent max-width="600">
    <v-card>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-link-variant</v-icon>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.addURL'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
          <v-row>
            <v-col cols="12">
              <p class="mb-2 body-1 font-weight-medium">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.urlName'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                outlined
                v-model="title"
                :rules="nameRules"
                :placeholder="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.title'
                  )
                "
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <p class="mb-2 body-1 font-weight-medium">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.url'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                outlined
                v-model="url"
                :rules="urlRules"
                :placeholder="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.url'
                  )
                "
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
          outlined
          @click="close"
          >{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
            )
          }}</v-btn
        >
        <v-btn
          elevation="0"
          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
          :disabled="!valid"
          @click="validate"
          >{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.save'
            )
          }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { insertURL, updateURL } from '@/service/course/livev2';
export default {
  props: {
    isDialogOpen: {
      type: Boolean,
    },
    closeDialog: {
      type: Function,
    },
    getListUrl: {
      type: Function,
    },
    liveId: {
      type: String,
    },
    urlDetail: {
      type: Object,
    },
    total: {
      type: Number,
    },
  },
  watch: {
    isDialogOpen: async function (newValue) {
      if (newValue) {
        if (this.urlDetail) {
          this.title = this.urlDetail.title;
          this.description = this.urlDetail.description;
          this.url = this.urlDetail.url;
        } else {
          this.clearData();
        }
      }
    },
  },
  data: () => ({
    valid: true,
    title: '',
    description: '',
    url: '',
  }),

  computed: {
    nameRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.titleRules'
          ),
      ];
    },
    urlRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.urlRules'
          ),
      ];
    },
  },

  methods: {
    async validate() {
      if (this.$refs.form.validate()) {
        if (this.urlDetail) {
          let result = await updateURL(this.liveId, this.urlDetail._id, {
            title: this.title,
            description: this.description,
            url: this.url,
          });
          if (result.status !== false) {
            this.close();
          }
        } else {
          let result = await insertURL(this.liveId, {
            prority: this.total,
            title: this.title,
            description: this.description,
            url: this.url,
          });
          if (result.status !== false) {
            this.close();
          }
        }
        //   let data = {
        //     title: this.title,
        //     url: this.url,
        //     idlivestream: this.liveId
        //   };
        //   let result = await insertURL(data)
        //  this.clearData()
      }
    },
    clearData() {
      this.title = '';
      this.url = '';
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async close() {
      await this.clearData();
      await this.closeDialog();
    },
  },
};
</script>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
</style>